const EditNoteChat = ({
  editText,
  setEditText,
  handleCloseEditNotePopup,
  editNoteApi
}) => {

  return (
    <div className="popup-body">
      <h5>Edit Note Chat</h5>
      <input 
      type='text' 
      className='form-control mb-3' 
      value={editText} 
      onChange={(e) => setEditText(e.target.value)}
      />
      <button className='btn btn_green_yellow mb-3 mr-2' onClick={editNoteApi}>Save Changes</button>
      <button className='btn btn-secondary mb-3' onClick={handleCloseEditNotePopup}>Cancel</button>
    </div>
  )
}

export default EditNoteChat